import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { COMPANY_MANAGED_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { isProjectsInJiraM2Enabled } from '@jira/platform__services-native-integration-projects/src/index.tsx';
import { WillRedirectOnLoadProviders } from '@atlassian/redirect-on-load/will-redirect-on-load-providers';
import type { JswProjectMenu$key } from './__generated__/JswProjectMenu.graphql';
import { JswExpandableProject } from './jsw-expandable-project/JswExpandableProject.tsx';
import { JswNonExpandableProject } from './jsw-non-expandable-project/JswNonExpandableProject.tsx';

type JswProjectMenuProps = {
	projectData: JswProjectMenu$key;
	menuItemAnchorRef?: React.RefObject<HTMLAnchorElement>;
	menuItemButtonRef?: React.RefObject<HTMLButtonElement>;
};

export const JswProjectMenu = ({
	projectData,
	menuItemAnchorRef,
	menuItemButtonRef,
}: JswProjectMenuProps): React.JSX.Element => {
	// eslint-disable-next-line @atlassian/relay/use-fragment-naming
	const project = useFragment<JswProjectMenu$key>(
		graphql`
			fragment JswProjectMenu on JiraProject
			@argumentDefinitions(
				isSubspaceCountEnabled: {
					type: "Boolean!"
					provider: "@jira/platform__graphql-relay-provider/src/atlas-project-native-integration-m2.relayprovider"
				}
			) {
				softwareBoardCount
				subspaceCount: subspaceCount_cse @include(if: $isSubspaceCountEnabled)
				projectStyle
				...JswNonExpandableProject
				...JswExpandableProject
			}
		`,
		// eslint-disable-next-line @atlassian/relay/use-fragment-naming
		projectData,
	);

	if (
		(project.softwareBoardCount &&
			project.softwareBoardCount > 0 &&
			project.projectStyle === COMPANY_MANAGED_PROJECT) ||
		(project.subspaceCount != null && project.subspaceCount > 0 && isProjectsInJiraM2Enabled())
	) {
		return (
			<WillRedirectOnLoadProviders>
				<JswExpandableProject projectData={project} menuItemButtonRef={menuItemButtonRef} />
			</WillRedirectOnLoadProviders>
		);
	}

	return <JswNonExpandableProject projectData={project} menuItemAnchorRef={menuItemAnchorRef} />;
};
